var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-loader",class:_vm.getClasses},[_c('div',{staticClass:"c-loader__spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }